import { Component, OnInit,Inject } from '@angular/core';
import { MiniAppsService } from '../miniapps.service';
import { ActivatedRoute } from '@angular/router';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {map, startWith} from 'rxjs/operators';
import {FormArray, FormBuilder, FormControl, FormGroup, AbstractControl} from '@angular/forms';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-launch-miniapps',
  templateUrl: './launch-miniapps.component.html',
  styleUrls: ['./launch-miniapps.component.css']
})
export class LaunchMiniAppsComponent implements OnInit {
 miniappsId:string;
 miniappsDetails:any;
 loginUserDetails:any;
 allPhoneNumbers:any;
 phoneNumber:string;
 webHookUrl:string;
 countryForm:FormGroup;

 countryList:any=[];
 stateList:any=[];
 cityList:any=[];

 dropdown_country_icon=false;
 dropdown_states_icon=false;

 selectedState=[];
 selectedCity=[];

 dropdownSettings:any={};
 showFilter=false;
 cities:any=[];
 selectedItems:any=[];
 stateEdit='';
 tags : string[] = [];

  constructor(private miniappsService:MiniAppsService,private activatedRoute:ActivatedRoute, private _matDialog: MatDialog,private _snackBar: MatSnackBar,private _formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.getAllCountrylist(0);
    this.loginUserDetails =JSON.parse(localStorage.getItem('loginUserDetails'))
    this.miniappsId=this.activatedRoute.snapshot.params.id
    this.getMiniAppsDetails()
    this.getMiniAppsDetailsByMerchantId()
    this.countryForm  = this._formBuilder.group({
      countries: this._formBuilder.array([this.createCountryFormGroup()])
    });
  }
  
  get form() { return this.countryForm.get('countries') as FormArray; }

  createCountryFormGroup(): FormGroup {
    return new FormGroup({
      'country': new FormControl([]),
      'states': new FormControl([]),
      'city':new FormControl([])
    })
  }

  addcountryFormGroup() {
    const countries = this.countryForm.get('countries') as FormArray
    countries.push(this.createCountryFormGroup());
    this.getAllCountrylist(countries.length-1);
  }

  removeOrClearcountry(i: number) {
    const countries = this.countryForm.get('countries') as FormArray
    if (countries.length > 1) {
      countries.removeAt(i)
    } else {
      countries.reset()
    }
  }

  onCityItemSelect(item:any, index){
    var arrayControl = this.countryForm.get('countries') as FormArray;
    arrayControl.controls[index].patchValue(item);
    this.cityList[index].map(e => { (e.name === item.name) ? e.checked = item.checked : null  });
  }

  split( val ) {
    return val.split( /,\s*/ );
  }

  extractLast( term ) {
    return this.split( term ).pop();
  }

  extractFirst( term ) {
    return this.split( term ).shift();
  }

  onStateItemSelect(item:any, index){
    var arrayControl = this.countryForm.get('countries') as FormArray;
    arrayControl.controls[index].patchValue(item);
    this.getCityByCountryState(this.extractFirst(arrayControl.controls[index].value.country), item, index);
    this.stateList[index].map(e => { (e.name === item.name) ? e.checked = item.checked : null });
  }

  selectedData(item:any, index:number) {
    var arrayControl = this.countryForm.get('countries') as FormArray;
    arrayControl.controls[index].patchValue(item);
    this.getStateByCountry(item.name, index);
    this.countryList[index].map(e => { (e.name === item.name) ? e.checked = item.checked : e.checked = false; });
  }

  getMiniAppsDetails(){
  this.miniappsService.getMiniAppsConfigurationById(this.miniappsId).subscribe(res=>{
  this.miniappsDetails=res.body
  this.webHookUrl = this.miniappsDetails.launch_url
  this.getMiniAppsLablelsByMiniAppsId();
  },error=>{

  })
  }

  getMiniAppsLablelsByMiniAppsId(){
    this.miniappsService.getLabelsWithMiniAppsId(this.miniappsId).subscribe(
      (res) =>{
        this.tags = res.data;
      }
    )
  }

  getMiniAppsDetailsByMerchantId(){
    this.miniappsService.getMiniAppsDetailsByMerchantId(this.loginUserDetails.merchant_id).subscribe(res=>{
    this.allPhoneNumbers=res.body.data
    this.allPhoneNumbers.forEach((element) => {
    if(element.mini_app_id == this.miniappsId){
    this.phoneNumber = element.mobile
    }
    }); 

    },error=>{

    })
  }

  getWebHookUrlByMiniAppsId(){
    // this.miniappsService.getWebHookUrl(this.miniappsId).subscribe(res=>{
    // this.webHookUrl =res.body.webhook_url
    // },error=>{

    // })
    this.webHookUrl = this.miniappsDetails.launch_url
  }

  getCountryCode(data) {
    return this.countryList[0].filter(x => x.name === data && x.iso2)[0];
  }

  openLaunchMiniAppspopup(){
    
    this._matDialog.open(LaunchMiniAppsDialog, {
      data: this.miniappsId,
    });
  }

  test(val) {
    console.log(val)
  }

  getStateByCountry(country: any, ind:number) {
    const particularCountry = this.countryList[ind].filter(x=> x.name === country);
    this.stateList[ind] = particularCountry[0].states;
    this.stateList[ind].map((element) => { element.checked = false; });
  }

  getAllCountrylist(ind) {
    this.miniappsService.getAllCountrylist().subscribe((res:any)=>{
      const c = ['India', 'Singapore'];
      this.countryList[ind] = res?.data.filter(x => c.indexOf(x.name) > -1 );
      this.countryList[ind].map((element) => { element.checked = false; });
    });
  }

  getCityByCountryState(country, state, ind) {
    this.miniappsService.getCityByCountryState(country, state.name).subscribe((res:any)=>{
      const a = res?.data.map((str) => ({ name: str,checked:false }));
      if(state.checked) {
        if(this.cityList[ind]) this.cityList[ind] = this.cityList[ind].concat(a);
        else this.cityList[ind] = a;
      } else {
        const old = new Set(a.map(({ name }) => name));
        this.cityList[ind] = this.cityList[ind].filter(({ name }) => !old.has(name));
      }
    });
  }

  onstateEdit(e?){
    var input_feild_value=(<HTMLInputElement>document.getElementById("state_input")).value;
    if(e?.key=="Backspace" && !input_feild_value.includes(this.selectedState.join(", ")+",") && this.selectedState.length > 0)
    {
      (<HTMLInputElement>document.getElementById("state_input")).value = this.selectedState.join(", ")+","
    }
    if(this.selectedState.length > 0) this.stateEdit= this.selectedState.join(", ")+","
  }

  stateSel(Obj, val, e) {
    if(Obj.indexOf(val) == -1 && e.target.checked) Obj.push(val);
    else if(!e.target.checked) Obj.splice(Obj.indexOf(val), 1);
  }
}

@Component({
  selector: 'launch-miniapps-dialog',
  templateUrl: 'launch-miniapps-dialog.html',
  styleUrls: ['./launch-miniapps.component.css','../miniapps.component.css'],
})
export class LaunchMiniAppsDialog {
  miniappsID:any
  copyURL:any
  horizontalPosition: MatSnackBarHorizontalPosition= 'end';
  verticalPosition: MatSnackBarVerticalPosition= 'top';
  shareableLink: any;
  constructor(public dialogRef: MatDialogRef<LaunchMiniAppsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _snackBar: MatSnackBar,private miniappsService:MiniAppsService) {
      this.miniappsID =data
      this.getShareableLink()
    }

  getShareableLink(){
    this.miniappsService.getMiniAppsShareableLink(this.miniappsID).subscribe(res=>{
      this.copyURL = res.body.shareable_link
    })
  }

  closePopup() {
    this.dialogRef.close();
  }
  
}

